const NotificationsCloseIcon = (props: any) => {
  return (
    <svg height="24" width="24" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M5 12L14 12" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M8.57143 8.42871L5 12.0001" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M8.57143 15.5714L5 12" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M18 6V18" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
    </svg>
  );
};

export default NotificationsCloseIcon;
